export const organizationClientRecordsTableViewId = 'client-records-table' as const;

export type OrganizationTableColumnFilterState = {
    selectedDiscreetValues?: string[];
};

export type OrganizationTableSortState = {
    columnKey: string;
    direction: 'asc' | 'desc';
};

export type ClientRecordsTableSettings = {
    columnFilters: Record<string, OrganizationTableColumnFilterState | undefined>;
    sortState?: OrganizationTableSortState;
};

export type UserSetting = {
    userSettingId: string;
    userId: string;
    organizationId: string;
    viewId: string;
    settings: Record<string, unknown>;
};

export const getUserSettingId = (userId: string, organizationId: string, viewId: string): string =>
    `${userId}#${organizationId}#${viewId}`;

export const isClientRecordsTableSettings = (settings: unknown): settings is ClientRecordsTableSettings => {
    if (!settings || typeof settings !== 'object') {
        return false;
    }

    const { columnFilters } = settings as ClientRecordsTableSettings;
    return typeof columnFilters === 'object' && columnFilters !== null;
};

export const getClientRecordsTableSettingsFromUserSetting = (
    setting: UserSetting,
): ClientRecordsTableSettings | null => {
    if (setting.viewId !== organizationClientRecordsTableViewId) {
        return null;
    }

    if (!isClientRecordsTableSettings(setting.settings)) {
        return null;
    }

    return setting.settings;
};

export const clientRecordsTableSettingsToUserSettingSettings = (
    tableSettings: ClientRecordsTableSettings,
): Record<string, unknown> => tableSettings;
